<template>
  <IntercomBadge :variant="variant">
    {{ label }}
  </IntercomBadge>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { IntercomBadge } from '@shared/components/intercom'
import { statusVariants, statusLabelKeys } from '../config/statusConfig.js'

const { t } = useI18n()

const props = defineProps({
  status: { type: String, required: true },
})

const variant = computed(() => statusVariants[props.status] || 'default')
const label = computed(() => {
  const key = statusLabelKeys[props.status]
  return key ? t(key) : props.status.replace(/_/g, ' ')
})
</script>
